module.exports = __webpack_public_path__ + "img/headphones.885e6a6c.png";